const nameOf = <T>(name: keyof T): string => name.toString();

export default nameOf;
